var cancelDispute = {
    modalHeader: 'Are you sure you want to cancel this dispute?',
    modalDescription: 'If you cancel, your dispute will be closed and we will not further investigate the dispute.',
    modalSubtitle: 'Select a reason for canceling your dispute:',
    reason1: 'I worked with Merchant to resolve.',
    reason2: 'I received my merchandise.',
    reason3: 'I received my credit.',
    reason4: 'I agree to the disputed charge.',
    reason5: 'Other',
    otherReason: 'Please briefly describe the reason:',
    confirmationHeader: 'Your cancelation request has been received and is being processed.',
    confirmationDescription: 'We will notify you with a letter once the claim has been closed. Please allow 7 business days for us to complete your request.',
    errorHeader: "We're Sorry",
    errorDescription: 'We are not able to cancel your dispute at this time. Please try again later.',
    title: 'Cancel Dispute',
    securityDisclaimerHelpText: "For your security, please don't enter personal information."
};
export default cancelDispute;
//# sourceMappingURL=cancelDispute.js.map